import React from 'react';

import { useAppSelector } from 'redux/store';
import { selectHour12Option, selectUseLocalTimezone } from 'redux/selectors/userSettings';
import { formatTimestamp } from 'helpers/formatDateToLocalTimezone';
import { formatDurationDH } from 'helpers/formatDuration';

export type DateTimeVariant = 'datetime' | 'date' | 'duration';

interface FormatDateTimeProps {
  value: string | number | Date | null | undefined;
  // Source timezone of `value` when not rendering in the browser's local
  // timezone (e.g. a row's scheduled_start_timezone). Falls back to UTC.
  sourceTimezone?: string | null;
  variant?: DateTimeVariant;
}

// Reactive timestamp renderer. Subscribing to the time-format and
// local-timezone preferences here is what lets a single preference toggle
// re-flow every rendered timestamp without a page reload.
const FormatDateTime = ({ value, sourceTimezone, variant = 'datetime' }: FormatDateTimeProps) => {
  const hour12 = useAppSelector(selectHour12Option);
  const localTimezone = useAppSelector(selectUseLocalTimezone);

  if (variant === 'duration') {
    return <>{formatDurationDH(value as number | string | null | undefined)}</>;
  }

  return (
    <>
      {formatTimestamp(value, {
        localTimezone,
        sourceTimezone,
        hour12,
        dateOnly: variant === 'date',
        fallbackTimezone: 'UTC',
        invalidValue: '',
      })}
    </>
  );
};

export default FormatDateTime;
